@import "./offset-teaser.default.scss";

.#{$prefix}offset-teaser-wrapper {
  display: grid;
  grid-template-columns: repeat(12, [col-start] 1fr);
  z-index: 3;

  @include for-size(phone) {
    grid-template-columns: 100%;
    grid-template-areas:
      "image"
      "content";
  }

  .#{$prefix}visible-background {
    position: absolute;
    right: 0;
    top: 0;
    width: calc((8 / 12) * 100%);
    height: 100%;
    background-color: v(visibleBackgroundColor);
    @include borderRadius("variant_two", "content");
    @include boxShadow("variant_two", "content");

    @include for-size(phone) {
      width: 100%;
    }

    &.#{$prefix}color-bar-active {
      @include colorBarBorder;
    }
  }

  .#{$prefix}image-layer {
    position: relative;
    width: 100%;
    grid-column: col-start / span 5;
    z-index: 4;

    @include for-size(phone) {
      grid-column: image;
      margin-bottom: 0;
    }

    .#{$prefix}image-wrapper {
      &.#{$prefix}ratio-1x1 {
        &::after {
          @include aspect-ratio(1, 1);
        }
      }

      &.#{$prefix}ratio-3x4 {
        &::after {
          @include aspect-ratio(3, 4);

          @include for-size(phone) {
            @include aspect-ratio(1, 1);
          }
        }
      }
    }
  }

  .#{$prefix}content-layer {
    width: 100%;
    grid-column: col-start 6 / -1;
    justify-content: initial;
    min-height: unset;

    @include for-size(phone) {
      grid-column: content;
    }

    .#{$prefix}content-wrapper {
      padding: 48px 48px 48px 48px;
      width: 100%;

      @include for-size(tablet) {
        width: 100%;
        padding: 40px 32px 48px 32px;
      }

      @include for-size(phone) {
        width: 100%;
        padding: 32px 24px 24px 24px;
      }

      .#{$prefix}offset-teaser-headline {
        padding-bottom: 32px;
        white-space: inherit;
      }
    }
  }
}

::slotted(p) {
  @include eon-typography("copy");
}
::slotted(eon-ui-image) {
  @include borderRadius("variant_two", "image");
  @include boxShadow("variant_two", "image");
}
